module.exports = __webpack_public_path__ + "img/thumbnails-12-typing-game.b1a67442.png";